import BreadCrumb from "Common/BreadCrumb";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { useEffect, useState } from "react";
import TotalPL from "./TotalPL";
import TopDeposit from "./TopDeposit";
import TopWinner from "./TopWinner";
import TopLosser from "./TopLosser";
import TopGamesPlayed from "./TopGamesPlayed";
import TotalOpenBets from "./TotalOpenBets";
import TopCasinoGamesPlayed from "./TopCasinoGamesPlayed";
import TrafficAnalysis from "./TrafficAnalysis";
import TotalBetsCountWithPL from "./TotalBetsCountWithPL";
import { settingServices } from "Utils/setting/services";
import { currentDateTime, getStartTimeOfDay } from "Utils/datefilter";
import MergedDashboard from "./MergedDashboard";
import TransactionStatus from "./TransactionStatus";
import moment from "moment";
import Loader from "Common/Loader";
import TotalClientPl from "./TotalClientPl";

interface sportPlPayload {
  sport_id: string;
  sport_name: string;
  profit_loss: number;
}

const B2CReport = () => {
  const currentDate = new Date();
  const [endDate, setEndDate] = useState<string | Date>(currentDateTime());
  const [totalPl, setTotalPl] = useState();
  const sevenDaysAgo = new Date(currentDate.setDate(currentDate.getDate()));
  const [startDate, setStartDate] = useState<string | Date>(
    getStartTimeOfDay(sevenDaysAgo)
  );
  const [sportData, setSportData] = useState<sportPlPayload[]>([]);
  const [data, setData] = useState<any>({});
  const [isLoading, setIsLoading] = useState<Record<string, boolean>>({
    data: true,
  });
  const fetchData = async (
    days: number,
    query: string[],
    section?: string | any
  ) => {
    const load = query?.[0];
    setIsLoading((prevLoading) => ({
      ...prevLoading,
      [load]: true,
    }));

    let from_date, to_date;

    if (days === 0) {
      from_date = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      to_date = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else {
      from_date = moment()
        .subtract(days, "days")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      to_date = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    }

    const { response } = await settingServices.getTotalReport({
      from_date,
      to_date,
      limit: 500,
      search: query,
    });

    if (response) {
      setData((prevData: any) => ({
        ...prevData,
        data: {
          ...prevData.data,
          ...response.data,
        },
      }));
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        [load]: false,
        data: false,
      }));
    }
  };
  useEffect(() => {
    fetchData(0, [
      "topCasinoQuery",
      "query",
      "activeClientsQuery",
      "dwQuery",
      "statementQuery",
      "plQuery",
      "transactionQuery",
      "winnersQuery",
      "losersQuery",
      "topGamesQuery",
      "openBetsQuery",
      "topCasinoQuery",
      "trafficAnalysisQuery",
      "betsCountPlQuery",
      "userDataQuery",
    ]);
  }, []);

  const user_Detail = localStorage.getItem("adminDetails");

  let userid = user_Detail ? JSON.parse(user_Detail || "") : "";
  const getSportWisePL = async () => {
    const { response } = await settingServices.getSportByPl({
      from_date: startDate,
      to_date: endDate,
      user_id: userid?._id,
    });

    if (response) {
      const customOrder = [
        "Cricket",
        "Session",
        "Soccer",
        "Tennis",
        "Casino",
        "QT",
      ];

      const sortedData = response?.data?.sort((a: any, b: any) => {
        const indexA = customOrder.indexOf(a.sport_name);
        const indexB = customOrder.indexOf(b.sport_name);

        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      setSportData(sortedData);
    }
  };
  const handleSportPl = async () => {
    setIsLoading((prevLoading) => ({
      ...prevLoading,
      data: true,
    }));
    getSportWisePL();

    const { response } = await settingServices.getTotalReport({
      from_date: startDate,
      to_date: endDate,
      limit: 500,
      search: [
        "topCasinoQuery",
        "query",
        "activeClientsQuery",
        "dwQuery",
        "statementQuery",
        "plQuery",
        "transactionQuery",
        "winnersQuery",
        "losersQuery",
        "topGamesQuery",
        "openBetsQuery",
        "topCasinoQuery",
        "trafficAnalysisQuery",
        "betsCountPlQuery",
        "userDataQuery",
      ],
    });
    if (response) {
      setData((prevData: any) => ({
        ...prevData,
        data: {
          ...prevData.data,
          ...response.data,
        },
      }));
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        data: false,
      }));
    }
  };

  useEffect(() => {
    getSportWisePL();
  }, [userid?._id]);

  useEffect(() => {
    const totalClientPLShare = sportData?.reduce(
      (total: any, currentItem: any) => total + currentItem.profit_loss,
      0
    );
    setTotalPl(totalClientPLShare);
  }, [sportData]);

  return (
    <div className="page-content">
      <Container fluid>
        <div className="position-relative mb-2">
          <BreadCrumb title="B2C Report" pageTitle="Dashboard" back />
          <Card>
            <Card.Body>
              <Form>
                <Row className="gy-3 align-items-end">
                  <Col lg={3}>
                    <Form.Label>Start Date</Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="2024-12-06 05:17:44"
                      pl
                      options={{
                        enableTime: true,
                        dateFormat: "Y-m-d H:i:s",
                        defaultDate: [startDate],
                        maxDate: endDate,
                      }}
                      value={startDate}
                      onChange={([date]: [Date]) => {
                        setStartDate(new Date(date));
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Form.Label>End Date</Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="2024-12-06 05:17:44"
                      pl
                      options={{
                        enableTime: true,
                        dateFormat: "Y-m-d H:i:s",
                        defaultDate: [endDate],
                        maxDate: currentDateTime(),
                      }}
                      value={endDate}
                      onChange={([date]: [Date]) => {
                        setEndDate(new Date(date));
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Button
                      className="me-2 btn-sm"
                      style={{ height: "38px" }}
                      onClick={handleSportPl}
                    >
                      <i className="fs-lg align-middle ri-filter-line"></i>{" "}
                      Submit
                    </Button>
                    <Button
                      variant="outline-primary"
                      className="btn-sm"
                      style={{ height: "38px" }}
                    >
                      <i className="fs-lg align-middle ri-refresh-line"></i>{" "}
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
          <Row>
            {sportData?.length !== 0 && (
              <Col xxl={6}>
                <Card className="card-height-100">
                  <div className="card-body">
                    <div className="table-resposive">
                      <Table>
                        <thead className="table-light">
                          <tr>
                            <th>Sports</th>
                            <th>P/L</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sportData?.length !== 0 ? (
                            sportData?.map((item: any) => {
                              return (
                                <tr>
                                  <td>{item?.sport_name}</td>
                                  <td
                                    className={
                                      item?.profit_loss < 0
                                        ? "text-danger"
                                        : "text-success"
                                    }
                                  >
                                    {item?.profit_loss}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                No Data Found!
                              </td>
                            </tr>
                          )}
                          {sportData && sportData?.length !== 0 && (
                            <tr>
                              <td
                                style={{
                                  fontWeight: 700,
                                }}
                              >
                                Total
                              </td>
                              <td
                                className={
                                  totalPl && totalPl < 0
                                    ? "text-danger"
                                    : "text-success"
                                }
                                style={{
                                  fontWeight: 700,
                                }}
                              >
                                {totalPl && Number(totalPl)?.toFixed(2)}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Card>
              </Col>
            )}
            {userid?.user_type_id === 0 && (
              <Col xxl={4}>
                <TotalClientPl />
              </Col>
            )}
          </Row>
          <Row>
            <MergedDashboard
              data={data}
              isLoading={isLoading}
              fetchData={fetchData}
              userId={userid?.user_type_id}
            />
            {userid?.user_type_id !== 0 && (
              <TransactionStatus
                data={data}
                isLoading={isLoading}
                fetchData={fetchData}
              />
            )}
            <TopWinner
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TopLosser
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TotalPL data={data} isLoading={isLoading} fetchData={fetchData} />
            {userid?.user_type_id !== 0 && (
              <TopDeposit
                isLoading={isLoading}
                data={data}
                fetchData={fetchData}
              />
            )}

            <TopGamesPlayed
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TotalOpenBets
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TopCasinoGamesPlayed
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TrafficAnalysis
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
            <TotalBetsCountWithPL
              isLoading={isLoading}
              data={data}
              fetchData={fetchData}
            />
          </Row>
        </div>
        {isLoading?.["data"] && <Loader />}
      </Container>
    </div>
  );
};

export default B2CReport;
